class ProductCardQuickAdd extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();
  }

  openSheet() {
    if (window.matchMedia("(hover: hover)").matches) return;
    this.classList.add("state--sheet-open");
    document.body.style.overflow = "hidden";
  }

  closeSheet() {
    this.classList.remove("state--sheet-open");
    document.body.style.overflow = "";
  }

  singleQuickAdd(_, element) {
    const container = element.closest(".spinner-container");
    if (container) {
      container.classList.add("state--loading");
    }

    const variantId = element.dataset.variantId;
  
    if (!variantId) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    this.addToCart(variantId, container);
  }

  variantQuickAdd(_, element) {
    const container = element.closest(".spinner-container");
    if (container) {
      container.classList.add("state--loading");
    }

    element.classList.add("is-selected");

    this.addToCart(element.dataset.variantId, container);
  }

  addToCart(variantId, container) {
    if (!variantId) {
      if (container) {
        container.classList.remove("state--loading");
      }
      return;
    }

    const data = new FormData();
    data.set("id", variantId);

    fetch("/cart/add.js", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        document.dispatchEvent(
          new CustomEvent("addtocart", { detail: response })
        );
        this.closeSheet();
        this.querySelectorAll(".quickadd-option").forEach((el) => el.classList.remove("is-selected"));
      })
      .catch((error) => {
        console.error("ProductCardQuickAdd: add to cart failed", error);
      })
      .finally(() => {
        if (container) {
          container.classList.remove("state--loading");
        }
      });
  }
}

customElements.define("product-card-quick-add", ProductCardQuickAdd);


